module.exports = __webpack_public_path__ + "static/media/player_level_C.126b4153.png";